import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, NgForm } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../environments/environment';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { MultipleEmailIdModel } from '../shared/models/MultipleEmailIdModel';
import { IPropertyDetails } from '../shared/models/propertydetails';
import { IShareOMProperties } from '../shared/models/ShareOmProperties';
import { SharePropertyEmailInputModel } from '../shared/models/SharePropertyEmailInputModel';
import { SharePropertyLinkedInInputModel } from '../shared/models/SharePropertyLinkedInInputModel';
import { PropertyListingService } from '../shared/providers/property-listing.service';
import { ToastService } from '../shared/providers/toast.service';
import { ValidationService } from '../shared/providers/validation.service';
import { HttpClient } from '@angular/common/http';
import { LoaderService } from '../shared/providers/loader.service';
import { CommonService } from '../shared/providers/common.service';
import { PropertyManagementService } from '../shared/providers/property-management.service';
import { IResponseModel } from '../shared/models/ResponseModel';
import { ISharedOMList } from '../shared/models/SharedOmUserDetails';
interface IUsersForShare {
  FirstName: string;
  LastName: string;
  EmailForShare: string;
  Id: number;
  EmailvalidationMessage: string;
  FirstNamevalidationMessage: string;
  LastNamevalidationMessage: string;
}
@Component({
  selector: 'app-share-omdocuments',
  templateUrl: './Share-OMDocuments.component.html',
  styleUrls: ['./Share-OMDocuments.component.css']
})

export class ShareOMDocumentscomponent implements OnInit {
  @Input() propertyIds: number[] = [];
  sharedList = {} as ISharedOMList;
  indexValue: number = 0;
  userListForOm: IUsersForShare[] = [];
  @Input() modalRefShareListing: BsModalRef;
  @Input() SourcePage: string = '';
  @Output() removeProperties = new EventEmitter();
  propertyList: IShareOMProperties[] = [];
  haveaccesstoviewlocation: boolean = true;
  sharePropertyEmailInputModel = {} as SharePropertyEmailInputModel;
  sharePropertyLinkedInInputModel = {} as SharePropertyLinkedInInputModel;
  protected readonly BASE_URL: string = environment.base_url;
  user: any;
  emailValid: boolean = true;
  emailvalidation: string = '';
  mailIds: MultipleEmailIdModel[];
  keyCode: number[];
  disableButton: boolean = true;
  isZCF: boolean = false;
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  DDColumns = [];
  dtoptions = {};
  isShareSubmit = false;
  response = {} as IResponseModel;
  propForm: FormGroup;
  usercount: number = 0;
  constructor(private _propertyService: PropertyListingService, private http: HttpClient, private authService: AuthenticationService, private _toastService: ToastService,
    public Validation: ValidationService, private _loaderService: LoaderService, private commonService: CommonService, private _propertyManagementService: PropertyManagementService) { }

  ngOnInit() {
    this.usercount = 0;
    this.addFirstUser();
    this.user = this.authService.user != null ? this.authService.user : '';
    this.mailIds = [];
    this.keyCode = [32, 188, 13];
    this.getPropertyList();
  }

  validEmail$(control: any) {

    if (control.value != "") {
      let serchfind: boolean;
      const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      serchfind = regexp.test(control.value);
      if (serchfind == false) {
        return {
          'validEmail$': true
        };
      }
    }

    return null;
  }

  public validators = [this.validEmail$];

  public errorMessages = {
    'validEmail$': 'Invalid Email Address'
  };

  getPropertyList() {
    let columns = [
      { data: 'PropertyName' },
      { data: 'State' },
      { data: 'City' },
      { data: 'Status' },
      { data: 'Brokers' }
    ];
    this.DDColumns = columns;
    const that = this;

    this.dtoptions = {
      pagingType: 'full_numbers',
      "pageLength": 20,
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
      },
      "order": [[0, "asc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        //this.IsDataProcessing = true;
        dataTablesParameters.Extra_param = {
          UserId: that.user.Id,
          PropertyLst: this.propertyIds,
        }

        const httpHeader = this.Validation.GetAuthHeader();
        that.http.post<DataTablesResponse>(
          this.BASE_URL + '/property/GetShareOMPropertyList/', dataTablesParameters, httpHeader).subscribe(resp => {
            if (resp != null) {
              this.propertyList = resp ? resp.data ? resp.data : [] : [];
              this._loaderService.display(false);
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data == null || resp.data.length === 0) {
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: []
                });
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
              /*   this.IsDataProcessing = false;*/
            }
          });
        this._loaderService.display(false);
      },
      columns: this.DDColumns
    };
  }

  shareList() {
    this.isShareSubmit = true;
    let IsFieldValid = this.checkValidation();
    let valid = true;

    if (this.Validation.IsinValid(this.sharedList.Description)) {
      valid = false;
    }
    else if (this.Validation.IsinValid(this.sharedList.ExpiryDate)) {
      valid = false;
    }
    else if (this.propertyIds.length == 0) {
      valid = false;
    }
    else if (!IsFieldValid) {
      valid = false;
    }
    if (valid && !this.propForm.invalid) {
      this._loaderService.display(true);
      //this.sharedList.EmailForShare = this.mailIds.map(function (data) { return data.value });
      this.sharedList.UserId = this.user.Id;
      this.sharedList.PropertyIds = this.propertyIds;
      this.sharedList.UserDetails = this.userListForOm;
      this._propertyManagementService.ShareOMToUsers(this.sharedList).subscribe(res => {
        this.response = res;
        if (this.response.IsSuccess) {
          this._toastService.addToast({
            title: 'Success',
            msg: 'OM shared successfully',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success'
          });
          this.modalRefShareListing.hide();
          this.userListForOm = [];
          this.propertyIds = [];
          this._loaderService.display(false);
          this.removeProperties.emit(0);
        }
        else {
          this._loaderService.display(false);
          this._toastService.addToast({ title: 'Error', msg: 'Something went wrong', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
      });
    }
  }


  getUserId(index: number): number {
    if (this.userListForOm) {
      return this.userListForOm[index].Id
    }
  }

  addNewUser() {
    let newUser: any = {
      FirstName: null,
      LastName: null,
      Id: (this.usercount + 1),
      EmailForShare: null
    };
    this.usercount = newUser.Id;
    this.userListForOm.push(newUser);
    const firstnameText = 'txtFirstName' + (newUser.Id);
    const lastNameText = 'txtLastName' + (newUser.Id);
    const emailText = 'txtEmail' + (newUser.Id);
    this.propForm.addControl(firstnameText, new FormControl(newUser.FirstName, Validators.required));
    this.propForm.addControl(lastNameText, new FormControl(newUser.LastName, Validators.required));
    this.propForm.addControl(emailText, new FormControl(newUser.EmailForShare, Validators.required));
    this.propForm.get(firstnameText).clearValidators();
    this.propForm.get(firstnameText).updateValueAndValidity();
    this.propForm.get(lastNameText).clearValidators();
    this.propForm.get(lastNameText).updateValueAndValidity();
    this.propForm.get(emailText).clearValidators();
    this.propForm.get(emailText).updateValueAndValidity();
  }

  get txtDescription() { return this.propForm.get('txtDescription'); }
  get expiryDate() { return this.propForm.get('expiryDate'); }
  addFirstUser() {
    this.propForm = new FormGroup({
      'txtDescription': new FormControl(this.sharedList.Description, [
        Validators.required,
      ]),
      'expiryDate': new FormControl(this.sharedList.ExpiryDate, [
        // Validators.required
      ]),
    });
    this.addNewUser();
  }

  checkValidation() {
    let validCount = 0;
    if (this.userListForOm != null && this.userListForOm.length > 0) {
      this.userListForOm.forEach(item => {
        if (item != null) {
          if (item.FirstName == null || item.FirstName == '' || item.FirstName == undefined) {
            item.FirstNamevalidationMessage = 'First Name is required';
            validCount = validCount + 1;
          }
          else {
            item.FirstNamevalidationMessage = '';
          }
          if (item.LastName == null || item.LastName == '' || item.LastName == undefined) {
            item.LastNamevalidationMessage = 'Last Name is required';
            validCount = validCount + 1;
          }
          else {
            item.LastNamevalidationMessage = '';
          }
          if (item.EmailForShare == null || item.EmailForShare == '' || item.EmailForShare == undefined) {
            item.EmailvalidationMessage = 'Email Address is required';
            validCount = validCount + 1;

          }
          else if (item.EmailForShare != null && item.EmailForShare != '' && item.EmailForShare != undefined) {
            if ((this.Validation.isEmail(item.EmailForShare) == false) && !this.Validation.IsinValid(item.EmailForShare)) {
              item.EmailvalidationMessage = 'Please enter valid Email Address';
              validCount = validCount + 1;
            }
            else {
              item.EmailvalidationMessage = '';
            }
          }
          else {
            item.EmailvalidationMessage = 'Email Address is required';
            validCount = validCount + 1;
          }
        }
      });

    }
    if (validCount == 0) {
      return true
    }
    else {
      return false;
    }
  }

  checkValidationMessage(users: any, typeId: number) {
    if (typeId == 1) {
      if (users.FirstName == null || users.FirstName == '' || users.FirstName == undefined) {
        users.FirstNamevalidationMessage = 'First Name Required';
      }
      else {
        users.FirstNamevalidationMessage = '';
      }
    }
    else if (typeId == 2) {
      if (users.LastName == null || users.LastName == '' || users.LastName == undefined) {
        users.LastNamevalidationMessage = 'Last Name Required';
      }
      else {
        users.LastNamevalidationMessage = '';
      }
    }
    else {
      if (users.EmailForShare != null && users.EmailForShare != '' && users.EmailForShare != undefined) {
        if ((this.Validation.isEmail(users.EmailForShare) == false) && !this.Validation.IsinValid(users.EmailForShare)) {

          users.EmailvalidationMessage = 'Please Enter Valid Email';
        }
        else {
          users.EmailvalidationMessage = '';
        }
      }
      else {
        users.EmailvalidationMessage = 'Email Is required';
      }
    }
  }

  onRemoveUser(userId: number) {
    if (userId != null && userId > 0) {
      let deleteduser = this.userListForOm.findIndex(f => f.Id == userId);
      if (deleteduser != null && deleteduser > -1) {
        this.userListForOm.splice(deleteduser, 1);
      }
    }
  }
}

